import { createContext } from "react";

// Host for routable V3 action pages: the layout hides the regular page while an action page is open.
export const ActionPageContext = createContext({ host: null, enter: () => {}, leave: () => {}, mark: () => {} });
